import SkeletonList from 'components/skeleton/skeleton-list/SkeletonList';
import React, { FC } from 'react';

interface VideoSkeletonProps {}

const VideoSkeleton: FC<VideoSkeletonProps> = () => {
  return <SkeletonList rows={2} />;
};

export default VideoSkeleton;
